import './ViewVehicle.scss';
import { useEffect, useState, useContext, Fragment } from 'react';
import { TesterVehicle, VehicleDocumentsViewModel } from '../../../../interfaces/tester.interface';
import { reactPlugin } from '../../../../services/appInsights.service';
import { withAITracking } from '@microsoft/applicationinsights-react-js';
import { Row, Col, Button } from 'react-bootstrap';
import VehicleDocuemnts from '../VehicleDocuemnts/VehicleDocuemnts';
import { ComponentModelPopup } from '../../../../interfaces/modal.interface';
import ComponentModel from '../../appUtilityComponent/ComponentModel/ComponentModel';
import VehicleIncidents from '../VehicleIncidents/VehicleIncidents';
import { UserAuthContext, Authorize } from "../../appLoginComponent/UserAuthContext";

type TParams = { vehicle: TesterVehicle, onEdit: any, onDelete: any, editVehicleId: number };

function ViewVehicle({ vehicle, onEdit, onDelete, editVehicleId }: TParams) {

    let { isAuthorized } = useContext(UserAuthContext) as Authorize;
    let [componentModal, setComponentModal] = useState({} as ComponentModelPopup);

    useEffect(() => {
        if (sessionStorage.getItem("Incident_VehicleId")) {
            if (sessionStorage.getItem("Incident_VehicleId") === vehicle.vehicleId.toString()) {

                var _incidentId = (sessionStorage.getItem("Incident_IncidentId")) ? sessionStorage.getItem("Incident_IncidentId") : "0";

                var incidentId: string = (_incidentId != null) ? _incidentId : "0";

                onVehicleIncidentsClick(vehicle, +incidentId);

                sessionStorage.removeItem("Incident_VehicleId");
                sessionStorage.removeItem("Incident_IncidentId");
            }
        }
    }, [vehicle]);

    const onClose = () => {
        setComponentModal({} as ComponentModelPopup);
    }

    const onDocumentsSave = (vehcileDocs: VehicleDocumentsViewModel) => {
        onClose();
    }

    const onVehicleDoumentsClick = (vehicle: TesterVehicle) => {
        setComponentModal({ Show: true, Title: "Vehicle Documents", HandleClose: () => { onClose() }, Component: <VehicleDocuemnts onClose={onClose} vehicle={vehicle} isReadonly={true} onDocumentsSave={onDocumentsSave} vehicleDocuments={{ vehicleId: vehicle.vehicleId, RegistrationDocument: { documentId: 0 } } as VehicleDocumentsViewModel}></VehicleDocuemnts> } as ComponentModelPopup);
    };

    const onVehicleIncidentsClick = (vehicle: TesterVehicle, selectedIncidentId: number) => {
        setComponentModal({ Show: true, Title: "Vehicle Incidents", HandleClose: () => { onClose() }, Component: <VehicleIncidents onClose={onClose} vehicleId={vehicle.vehicleId} selectedIncidentId={selectedIncidentId}></VehicleIncidents> } as ComponentModelPopup);
    };

    return (
        <Row className="animation-content">
            <Col className="col-lg">
                {vehicle &&
                    <Row>
                        <Col className="col-lg border-right">
                            <dl>
                                <div className="row">
                                    <div className="col-sm-8">
                                        <dt>TYPE - {vehicle.vehicleTypeId === "1" ? "VIN" : "UNIQUE ID"}</dt>
                                        <dd>{vehicle.vehicleTypeId === "1" ? "Automated" : "PDD"} - {vehicle.vehicleTypeId === "1" ? vehicle.vin : vehicle.uniqueNumber}</dd>
                                    </div>
                                    <div className="col-sm-4">
                                        <dt>ISSUED STATE {vehicle.vehicleTypeId === "1" ? " - LICENSE PLATE" : ""}</dt>
                                        <dd>{vehicle.vehicleRegistrationStateCd} {vehicle.vehicleTypeId === "1" ? " - " + vehicle.licensePlateNumber : ""}</dd>
                                    </div>
                                </div>
                                <div className="row">

                                    <div className="col-sm-8 ">
                                        <dt>YEAR - MAKE - MODEL</dt>
                                        <dd>{vehicle.year} {vehicle.vehicleMake} {vehicle.vehicleModel}</dd>
                                    </div>

                                    <div className="col-sm-4 ">
                                        <dt>ENGINE TYPE</dt>
                                        <dd>{vehicle.vehicleEngineType} {vehicle.vehicleEngineType === "Other" ? "- " + vehicle.otherEngineType : ""}</dd>
                                    </div></div>
                            </dl>
                        </Col>
                        {isAuthorized("AV_View_Incidents") ? <Fragment>
                            <Col className="border-right pr-1 mw-md-100px text-center">
                                <Row>
                                    <Col className="mb-2 mt-2 documents-label text-center">INCIDENT</Col>
                                </Row>
                                <Row >
                                    <Col>
                                        <Button disabled={vehicle.incidentsCount === 0} variant="outline-secondary" className="btn-round mr-2 btn-32-32 btn-doc-num btn-incident-num" onClick={() => onVehicleIncidentsClick(vehicle, 0)}>{vehicle.incidentsCount}</Button>
                                    </Col>
                                </Row>
                            </Col></Fragment> : ""}

                        <Col className="col-lg mw-md-300px border-right text-center">
                            <Row>
                                <Col className="mb-2 mt-2 documents-label text-center">CLICK BELOW TO UPLOAD REQUIRED FIELDS</Col>
                            </Row>
                            <Row >
                                <Col>
                                    {vehicle.DocumentsUploaded.map(x =>
                                        <Button key={x} variant="outline-secondary" className={"vehicle-doc-round-button btn-round me-2 btn-32-32 btn-doc-num " + (Number.isNaN(+x) ? "uploded-doc" : "")} onClick={() => onVehicleDoumentsClick(vehicle)}>{x}</Button>
                                    )}
                                </Col>
                            </Row>
                            {
                                vehicle.DocumentsUploaded.filter(x => Number.isNaN(+x)).length < 6 &&
                                <Row>
                                    <Col className="text-not-available-on-mobile-app">
                                        NOT AVAILABLE ON MOBILE APP
                                    </Col>
                                </Row>
                            }
                        </Col>
                        <Col className="col-lg mw-md-200px text-center">
                            <Button disabled={editVehicleId >= 0} className="btn-vehicle-round btn-edit btn-default me-2" variant="light" onClick={() => { onEdit(vehicle.vehicleId) }}>EDIT</Button>
                            <Button disabled={editVehicleId >= 0 || vehicle.incidentsCount > 0} className="btn-vehicle-round btn-delete btn-default" variant="light" onClick={() => { onDelete(vehicle) }}>DELETE</Button>
                        </Col>
                    </Row>
                }
            </Col>
            <ComponentModel modal={componentModal}></ComponentModel>
        </Row>
    );
}

export default withAITracking(reactPlugin, ViewVehicle);